import { updateSessionItem } from '../helpers/sessionHelper';
import {
  updatePostCodeInSearch,
  updateCountryStateInSearch,
  updateAddressInSearch,
  updateCityInSearch,
} from '../reducers/search/searchReducer';
import {
  setDisabledPrevButton,
  setOperation,
  updateSelectedService,
} from '../reducers/app/appReducer';
import { StartAppListeningFunction } from './index';

export const initAppListeners =
  (startAppListening: StartAppListeningFunction) => () => {
    startAppListening({
      actionCreator: updateSelectedService,
      effect: (action) => {
        updateSessionItem('selected', {
          serviceId: action.payload || '',
          // TODO: will be added in upcoming PR
          // serviceCode: action.payload?.serviceCode || '',
        });
      },
    });

    startAppListening({
      actionCreator: setOperation,
      effect: (action) => {
        updateSessionItem('operation', action.payload);
      },
    });

    startAppListening({
      actionCreator: updatePostCodeInSearch,
      effect: (action) => {
        updateSessionItem('search', { postCode: action.payload });
      },
    });

    startAppListening({
      actionCreator: updateCountryStateInSearch,
      effect: (action) => {
        updateSessionItem('search', { state: action.payload });
      },
    });

    startAppListening({
      actionCreator: updateAddressInSearch,
      effect: (action) => {
        updateSessionItem('search', { address: action.payload });
      },
    });

    startAppListening({
      actionCreator: updateCityInSearch,
      effect: (action) => {
        updateSessionItem('search', { city: action.payload });
      },
    });

    startAppListening({
      actionCreator: setDisabledPrevButton,
      effect: (action) => {
        updateSessionItem('disabledPrevButton', action.payload);
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return (
          currentState.app.selected.storeId !==
          previousState.app.selected.storeId
        );
      },
      effect: (_, listenerApi) => {
        updateSessionItem('selected', {
          storeId: listenerApi.getState().app.selected.storeId,
        });
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return (
          currentState.app.selected.timeSlot !==
          previousState.app.selected.timeSlot
        );
      },
      effect: (_, listenerApi) => {
        updateSessionItem('selected', {
          timeSlot: listenerApi.getState().app.selected.timeSlot,
        });
      },
    });

    startAppListening({
      predicate: (_, currentState, previousState) => {
        return currentState.timeSlots.from !== previousState.timeSlots.from;
      },
      effect: (_, listenerApi) => {
        updateSessionItem('from', listenerApi.getState().timeSlots.from);
      },
    });
  };
